import React, { useState, useEffect } from 'react'
import '../../../styles/Pages/Auth/otp.style.css'
import { Helmet } from 'react-helmet'
import LeftTemp from '../../../components/Auth/LeftTemp'
import logo from '../../../assets/Images/loginImg/Login_logo.png'
import arrow from '../../../assets/Icons/Pages/Auth/BsArrowRight.svg'
import OtpInput from 'react-otp-input';

const Body = () => {

  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(120);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleResendOTP = () => {
    console.log("OTP sent");
    setTimer(120); // Reset timer to 2 minutes
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className='OTP-body'>
      <Helmet>
        <title>OTP Verification - OMS</title>
      </Helmet>
      <div className='OTP-left-container'>
        <LeftTemp />
      </div>
      <div className='OTP-right-container'>
        <h3>Enter OTP</h3>
        <div className='OTP-form'>
          <img src={logo} alt="Logo" />
          <div className='OTP-form-wrapper'>
            <div className='OTP-input-container'>
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span> </span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  border: "1px solid #B8B8B8",
                  borderRadius: "3px",
                  width: "35.96685028076172px",
                  height: "35.96685028076172px",
                  fontSize: "20px",
                  color: "#000",
                  fontWeight: "bold",
                  caretColor: "blue",
                  margin: "0 8px",
                  outline: "none",
                }}
              />
              <hr />
              <div className='OTP-resend-timer'>
                <p>{formatTime(timer)}</p>
              </div>
              <div className='OTP-resend'>
                <p onClick={handleResendOTP}>Resend OTP</p>
              </div>
            </div>
            <button>Next</button>
            <img src={arrow} alt="" className='arrow' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Body
